// The work-item vocabulary, shared by every back-office screen that shows or
// edits one.
//
// These mirror WorkItem on the backend (back_office/models.py). The hierarchy
// rules below are a copy of WorkItem.clean(): the server is still the
// authority and will reject a bad parent, but duplicating the rule here lets
// the edit form grey out impossible choices instead of letting someone submit
// and collect a 400.
export const WORK_ITEM_STATUSES = [
    {value: 'backlog', label: 'Backlog', chip: 'bg-gray-100 text-gray-700'},
    {value: 'planned', label: 'Not Started', chip: 'bg-blue-100 text-blue-800'},
    // Between Not Started and In Progress because that is where it sits in
    // time: the one thing this person picks up when the current work is
    // done. Warm, and a shade short of the In Progress yellow, so the two
    // read as neighbours on the board rather than as the same state.
    {value: 'next', label: 'Next', chip: 'bg-orange-100 text-orange-800'},
    {value: 'in_progress', label: 'In Progress', chip: 'bg-yellow-100 text-yellow-800'},
    {value: 'test_review', label: 'Test / Review', chip: 'bg-purple-100 text-purple-800'},
    {value: 'done', label: 'Complete', chip: 'bg-green-100 text-green-800'},
    {value: 'wont_do', label: 'Not Relevant', chip: 'bg-gray-200 text-gray-600'},
]

export const WORK_ITEM_KINDS = [
    {value: 'epic', label: 'Epic'},
    {value: 'milestone', label: 'Milestone'},
    {value: 'story', label: 'Story'},
    {value: 'task', label: 'Task'},
]

// Which kinds a given kind may hang from. An epic is a root and takes none.
// A milestone usually describes part of an epic, so it may hang under one --
// or stand alone, since KINDS_REQUIRING_PARENT is empty. Stories and tasks
// may hang under a milestone, which makes it a grouping and not just a label.
export const ALLOWED_PARENT_KINDS = {
    epic: [],
    milestone: ['epic'],
    story: ['epic', 'milestone'],
    task: ['epic', 'milestone', 'story'],
}

// Kinds for which a parent is mandatory rather than merely permitted.
// Empty, mirroring WorkItem.REQUIRES_PARENT: nothing is forced to have a
// parent. ALLOWED_PARENT_KINDS above still says what MAY hold what, so the
// pickers keep offering only legal parents.
export const KINDS_REQUIRING_PARENT = []

export function workItemStatusChip(value) {
    const found = WORK_ITEM_STATUSES.find(s => s.value === value)
    return found ? found.chip : ''
}

export function workItemKindClass(value) {
    if (value === 'epic') return 'bg-indigo-100 text-indigo-800'
    // Warmer than the rest on purpose: a milestone carries a date somebody
    // outside the team may be holding us to, so it should catch the eye.
    if (value === 'milestone') return 'bg-amber-100 text-amber-900'
    if (value === 'story') return 'bg-sky-100 text-sky-800'
    return 'bg-gray-100 text-gray-600'
}
